export default "__VITE_ASSET__f207ef7e__"